import { AI_VERIFICATION_TYPES } from "@redotech/redo-model/return-flow";
import * as z from "zod/v4";

export const classifyClaimImage = {
  name: "classifyClaimImage" as const,
  input: z.object({
    imageUrl: z.string(),
    verificationType: z.enum(AI_VERIFICATION_TYPES as [string, ...string[]]),
    itemDetails: z.string().optional(),
    itemImageUrl: z.string().optional(),
  }),
  output: z.object({
    category: z.string().nullable(),
    confidence: z.number().optional(),
    reason: z.string(),
  }),
};
